import {
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import {
  addPresciptionItemToSingleHerbList,
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
  customFormulaPostAction,
  editSingleHerbItem,
  getAcumaticaHerbById,
  removeItemFromSingleHerbList,
  renderFormulaList,
} from "../../actions/formulaAction";
import { getCreatePrescriptionPatients } from "../../actions/patientAction";
import {
  getUnfinalizedPrescription,
  practitonerPrescriptionPostAction,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import {
  getPrescriptionFormSettings,
  getRememberSettings,
} from "../../actions/settingsActions";
import RxIcon from "../../assets/images/rx-icon.png";
import UndoIcon from "../../assets/images/undo-redo-icon.png";
import EditableInputWithIcons from "../../components/EditableInputWithIcons";
import FormulaList from "../../components/FormulaList";
import ItemSwitch from "../../components/ItemSwitch";
import Loader from "../../components/Loader";
import PacketCounter from "../../components/PacketCounter";
import PrescriptionNoteSection from "../../components/PrescriptionNoteSection";
import ServingsSection from "../../components/ServingsSection";
import SingleHerbList from "../../components/SingleHerbList";
import SubtotalSection from "../../components/SubtotalSection";
import TotalPrescibed from "../../components/TotalPrescribed";
import {
  ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED,
  HERBS_BY_FORMULA_ID_RECEIVED,
} from "../../constants/types/formulaType";
import {
  getAdminDetail,
  getFixedDosage,
  getUserDetail,
} from "../../utils/helper";
import AddHerbPopup from "../CustomFormulaBuilder/AddHerbPopup";
import FormulaFinderPopup from "../CustomFormulaBuilder/FormulaFinderPopup";
import GranularToRawPopup from "../CustomFormulaBuilder/GranularToRawPopup";
import RawToGranularPopup from "../CustomFormulaBuilder/RawToGranularPopup";
import SaveAsCustomPopup from "./SaveAsCustomPopup";
import Input from "../../components/WraapperComponent/Input";
import SuntenFormula from "../../components/SuntenFormula";
import GranularMultiplier from "../../components/GranularMultiplier";
import WarningPopup from "./WarningPopup";
import SuntenRemoveFormulaPopup from "../CustomFormulaBuilder/SuntenRemoveFormulaPopup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const MainPrescriptionPage = ({
  multiplier,
  setMultiplier,
  setTotalPacket,
  totalPacket,
  disease,
  setDisease,
  pattern,
  setPattern,
  formula,
  setFormula,
  mod,
  setMod,
  printHerbAmount,
  setPrintHerbAmount,
  formulaName,
  setFormulaName,
  formulaNote,
  setFormulaNote,
  commission,
  setCommission,
  practitionerCommission,
  prepMethod,
  setPrepMethod,
  patientName,
  setPatientName,
  setPatientFirstName,
  setPatientLastName,
  setPatientEmail,
  setPatientPhone,
  setFullscriptId,
  patientId,
  setPatientID,
  setPpcId,
  ppcId,
  packetsPerDay,
  setPacketsPerDay,
  days,
  setDays,
  scoops,
  setScoops,
  timePerDay,
  setTimePerDay,
  totalValue,
  setTotalValue,
  prepValue,
  setPrepValue,
  setActiveSection,
  patientInstruction,
  setPatientInstruction,
  pharmacyInstruction,
  setPharmacyInsytruction,
  notesOnPrescription,
  setNotesOnPrescription,
  isFullscriptConnected,
  fullscriptId,
  rawGramPerDayBeforeConversion,
  setRawGramPerDayBeforeConversion,
}) => {
  const isRaw = useSelector((state) => state.formula.present.isRawType);
  const [showAddHerb, setShowAddHerb] = useState(false);
  const [showFormulaFinderPopup, setShowFormulaFinderPopup] = useState(false);
  const [showRawToGranular, setShowRawToGranular] = useState(false);
  const [showGranularToRaw, setShowGranularToRaw] = useState(false);
  const [showSuntenRemovePopup, setShowSuntenRemovePopup] = useState(false);
  const [minimumTabletQuantity, setMinimumTabletQuantity] = useState(50);
  const [minimumGramQuantity, setMininumGramQuantity] = useState(50);
  const appLoading = useSelector((state) => state.alert.appLoading);
  const role = useSelector((state) => state.role.role);
  const [isLoading, setIsLoading] = useState(true);
  const unfinalizedPrescriptionId = useSelector(
    (state) => state.prescription.unfinalizedPrescriptionId
  );
  const prescription = useSelector(
    (state) => state.prescription.practitionerUnfinalizedPrescriptionDetail
  );
  const prescriptionPageTabShowItems = useSelector(
    (state) => state.prescription.prescriptionPageTabShowItemList
  );
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  const overallTotal = useSelector((state) => state.formula.present.overall);
  const renderList = useSelector(
    (state) => state.formula.present.renderFormulaList
  );
  const prescriptionFormFields = useSelector(
    (state) => state.settings.prescriptionFormFields
  );
  const rememberSettings = useSelector(
    (state) => state.settings.rememberSettings
  );

  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [isConverted, setIsConverted] = useState(false);
  const dispatch = useDispatch();
  const ref = useRef(null);
  const totalDosageRef = useRef(null);
  const changeFormulaTypeSwitch = () => {
    if (formulas.length <= 0 && singleHerbList <= 0) {
      if (isRaw) {
        if (rememberSettings?.showGranularConversionPopup) {
          setShowGranularToRaw(true);
        } else {
          setRawGramPerDayBeforeConversion(getValueBeforeConversion());
          dispatch(changeFormulaType(!isRaw, 0));
          setPrepMethod &&
            setPrepMethod(
              prescriptionFormFields?.preparationMethods?.find((x) => x.id == 1)
            );
          setDays(0);
          setTimePerDay(0);
        }
      } else {
        dispatch(changeFormulaType(!isRaw, 0));
      }
      setMultiplier(1);
    } else {
      if (isRaw) {
        setShowRawToGranular(true);
      } else {
        if (formulas.some((x) => x.isSuntenFormula)) {
          setShowSuntenRemovePopup(true);
        } else {
          dispatch(changeFormulaTypeFromGranularToRaw(!isRaw, multiplier));
        }
      }
    }
    setPrepMethod(null);
  };
  const pastFormulaState = useSelector((state) => state.formula.past);
  const futureFormulaState = useSelector((state) => state.formula.future);
  useEffect(() => {
    dispatch(
      getPrescriptionFormSettings(() => {
        if (unfinalizedPrescriptionId > 0 && prescription.length < 1) {
          dispatch(
            getUnfinalizedPrescription(unfinalizedPrescriptionId, () => {
              setIsLoading(false);
            })
          );
        } else {
          setIsLoading(false);
        }
      })
    );

    dispatch(getRememberSettings());
  }, [dispatch]);

  const groupByFormulaId = (list, key) => {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);

      return rv;
    }, {});
  };

  const isNearMultipleOfValue = (valueToCheck, multiple) => {
    const multipleOfValue = Math.round(valueToCheck / multiple) * multiple;
    const upperRange = parseFloat(
      prescriptionFormFields.maximumGramForCreation
    );
    const lowerRange = parseFloat(
      prescriptionFormFields.minimumGramForCreation
    );
    const lowerBound = multipleOfValue - lowerRange;
    const upperBound = multipleOfValue + upperRange;

    return valueToCheck >= lowerBound && valueToCheck <= upperBound;
  };

  useEffect(() => {
    if (prescriptionFormFields?.showRawType && !unfinalizedPrescriptionId > 0) {
      dispatch(changeFormulaType(true, 0));
    }
  }, [prescriptionFormFields]);

  const getPreparationValue = (prepMethod) => {
    let prepValue = 0;
    if (prepMethod) {
      if (!prepMethod?.isRaw) {
        const weight = overallTotal.totalDosage;
        const nearestLowerMultiple =
          Math.floor(weight / parseFloat(prepMethod.multiple)) *
          parseFloat(prepMethod.multiple);
        const excess = weight - nearestLowerMultiple;
        let adjustedWeight;

        if (
          excess <= parseFloat(prescriptionFormFields.maximumGramForCreation)
        ) {
          adjustedWeight = weight - excess;
        } else {
          adjustedWeight = weight;
        }
        adjustedWeight = adjustedWeight == 0 ? weight : adjustedWeight;
        prepValue =
          Math.ceil(adjustedWeight / parseFloat(prepMethod.perUnitQuantity)) *
          parseFloat(prepMethod.preparationValue);
      } else {
        prepValue = parseFloat(prepMethod.preparationValue) * totalPacket;
      }
    }
    return prepValue;
  };

  useEffect(() => {
    if (unfinalizedPrescriptionId > 0 && prescription[0] && renderList) {
      dispatch(
        changeFormulaType(!prescription[0]?.Dosage_Type, 0, () => {
          setDisease(prescription[0]?.DC_Custom);
          setPattern(prescription[0]?.DSC_Custom);
          setFormula(prescription[0]?.FORM_Custom);
          setRawGramPerDayBeforeConversion(
            prescription[0]?.PRSC_Raw_Daily_Dosage
          );
          setMod(prescription[0]?.MOD_Custom);
          setCommission(prescription[0]?.Markup);
          setPrepMethod(
            prescriptionFormFields?.preparationMethods?.find(
              (x) => x.id == prescription[0]?.Prep_Method
            )
          );
          setDays(prescription[0]?.Serving_Days);
          setTimePerDay(prescription[0]?.Serving_Per_Day);
          setPacketsPerDay(prescription[0]?.Serving_Per_Day);
          setTotalPacket(prescription[0]?.Serving_Total);
          setPatientName(prescription[0]?.Patient_Name);
          setPatientFirstName(prescription[0]?.Patient_First_Name);
          setPatientLastName(prescription[0]?.Patient_Last_Name);
          setPatientEmail(prescription[0]?.Patient_Email);
          setPatientPhone(prescription[0]?.Patient_Phone);
          setPrintHerbAmount(prescription[0]?.printHerbAmount);
          setFullscriptId(
            prescription[0].Fullscript_ID ? prescription[0].Fullscript_ID : 0
          );
          setPatientID(prescription[0]?.Patient_ID);
          setScoops(prescription[0]?.Serving_Amount);
          setPatientInstruction(prescription[0]?.Patient_Instruct);
          setPharmacyInsytruction(prescription[0]?.Pharmacy_Instruct);
          setNotesOnPrescription(prescription[0]?.PRSC_Practitioner_Note);
          setPpcId(prescription[0]?.PPC_ID);
          if (prescription[1]?.length > 0) {
            prescription[1]?.forEach((x) => {
              if (x.form_id === 0) {
                dispatch(addPresciptionItemToSingleHerbList(x));
                dispatch(
                  editSingleHerbItem(
                    x.herb_id,
                    prescription[0]?.Dosage_Type === 0
                      ? x.dosage / prescription[0]?.Serving_Total
                      : x.dosage
                  )
                );
              }
            });
            let formulas = Object.entries(
              groupByFormulaId(prescription[1], "form_id")
            );
            formulas.forEach((formula) => {
              if (formula[0] !== "0") {
                if (prescription[0]?.Dosage_Type === 0) {
                  formula[1].forEach(
                    (x) =>
                      (x.dosage = x.dosage / prescription[0]?.Serving_Total)
                  );
                }
                debugger;
                if (formula[1][0].herb_id == 0) {
                  dispatch({
                    type: ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED,
                    payload: {
                      data: formula[1][0],
                      formula_id: formula[1][0].form_id,
                      formula_name: formula[1][0].form_display,
                    },
                  });
                } else {
                  dispatch({
                    type: HERBS_BY_FORMULA_ID_RECEIVED,
                    payload: {
                      data: formula[1],
                      formula_id: formula[1][0].form_id,
                      formula_name: formula[1][0].form_display,
                      modification_name: formula[1]?.find(
                        (mod) => mod.mod_id > 0
                      )?.mod_display,
                    },
                  });
                }
              }
            });
            debugger;
            if (prescription[0]?.Dosage_Type === 1) {
              dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
              dispatch(
                addPresciptionItemToSingleHerbList({ herb_id: 0, dosage: 0 })
              );
              dispatch(removeItemFromSingleHerbList(0));
              dispatch(changeFormulaTypeFromDays(false, 1));
            }
          }
          dispatch(renderFormulaList(false));
        })
      );
      dispatch(UndoActionCreators.clearHistory());
    }
  }, [prescription]);
  const saveAsCustomFormula = () => {
    let herbList = [];
    formulas.forEach((x) => {
      x.formulaHerbs.forEach((y) => {
        herbList.push({
          HERB_ID: y.id,
          dosage_front: y.dosage,
        });
      });
    });
    singleHerbList.forEach((x) => {
      herbList.push({
        HERB_ID: x.id,
        dosage_front: x.dosage,
      });
    });
    const data = {
      name: formulaName,
      favorite: isFavorite,
      note: formulaNote,
      total_dosage: overallTotal.totalDosage,
      dosage_type: isRaw ? 0 : 1,
      herbs: herbList,
    };

    var params = {
      action: "addeditCustomFormula",
      data: data,
      token: getUserDetail()?.token,
    };
    dispatch(
      customFormulaPostAction({ params: params }, () => {
        setFormulaName("");
        setFormulaNote("");
        setIsFavorite(false);
      })
    );
  };

  const savePrescription = (fromReview, fromSave, toFullscript = false) => {
    dispatch(renderFormulaList(false));
    if (fromReview) {
      if (formulas.length < 1 && singleHerbList.length < 1) {
        dispatch({
          type: "ERROR",
          payload: "The Formula has no herbs",
        });
        return;
      }
      if (!prepMethod && !isRaw) {
        dispatch({
          type: "ERROR",
          payload: "Please select a preparation method",
        });
        ref.current.scrollIntoView({ behavior: "smooth", block: "end" });
        ref.current.style.border = "1px solid red";
        return;
      }

      // if (isRaw) {
      //   if (days < 1) {
      //     dispatch({
      //       type: "ERROR",
      //       payload: "Days cannot be set to 0",
      //     });
      //     return;
      //   }
      //   if (packetsPerDay < 1) {
      //     dispatch({
      //       type: "ERROR",
      //       payload: "Packet/Day cannot be set to 0",
      //     });
      //     return;
      //   }
      //   if (totalPacket < prepMethod.minimumGram) {
      //     dispatch({
      //       type: "ERROR",
      //       payload: `Requires a minimum of ${prepMethod.minimumGram} packets for ${prepMethod.prepMethod}`,
      //     });
      //     return;
      //   }

      //   if (totalPacket > prepMethod.maximumGram) {
      //     dispatch({
      //       type: "ERROR",
      //       payload: `Requires a maximum of ${prepMethod.maxmimumGram} packets for ${prepMethod.prepMethod}`,
      //     });
      //     return;
      //   }
      // }
      if (!isRaw) {
        if (prescriptionFormFields.requireServing) {
          if (scoops < 1) {
            dispatch({
              type: "ERROR",
              payload: "Scoop cannot be set to 0",
            });
            return;
          }
          if (days < 1) {
            dispatch({
              type: "ERROR",
              payload: "Days cannot be set to 0",
            });
            return;
          }
          if (timePerDay < 1) {
            dispatch({
              type: "ERROR",
              payload: "Time/Day cannot be set to 0",
            });
            return;
          }
        }
        if (overallTotal.totalDosage < prepMethod.minimumGram) {
          dispatch({
            type: "ERROR",
            payload: `Requires a minimum of ${prepMethod.minimumGram} grams for ${prepMethod.prepMethod}`,
          });
          totalDosageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          totalDosageRef.current.style.border = "1px solid red";
          return;
        }
        if (overallTotal.totalDosage > prepMethod.maximumGram) {
          dispatch({
            type: "ERROR",
            payload: `Requires a maximum of ${prepMethod.maximumGram} grams for ${prepMethod.prepMethod}`,
          });
          return;
        }
      }
    }

    let herbList = [];
    let error = false;
    formulas.some((x) => {
      x.formulaHerbs.some((y) => {
        if (!isRaw && y.granularPrice == 0 && fromReview) {
          dispatch({
            type: "ERROR",
            payload:
              "Your prescription is invalid, please remove herbs that are unavailable",
          });
          error = true;
          return true;
        }

        if (role.val === 4 && y.isToxic) {
          dispatch({
            type: "ERROR",
            payload:
              "Students are not able to prescribe potentially toxic herbs. Please remove them from the prescription.",
          });
          error = true;
          return true;
        }

        if (!isRaw && y.granularQuantity < y.dosage && fromReview) {
          dispatch({
            type: "ERROR",
            payload:
              "Please remove any herbs from your prescription that are currently out of stock",
          });
          error = true;
          return true;
        }

        if (y.dosage == 0 && fromReview) {
          dispatch({
            type: "ERROR",
            payload: "The minimum dosage can't be zero.",
          });
          error = true;
          return true;
        }

        herbList.push({
          HERB_ID: y.id,
          dosage_front: y.dosage,
          Formula_ID: x.formulaId,
          HERB_Display: y.name,
          Is_Custom_Formula: y.isCustom ? 1 : 0,
          MOD_Behavior: y.isModification,
          Is_Form_Additional: y.isAdditional ? 1 : 0,
          MOD_ID: y?.modId,
          Price_Granular: y.granularPrice,
          Price_Raw: y.rawPrice,
          dosage_granular_back: y.dosageInFloat,
          dosage_granular_front: y.dosage,
          herb_price_granular:
            Math.ceil(
              ((parseFloat(y.dosage) * y.granularPrice) / 10000) * 100
            ) / 100,
          herb_price_raw:
            Math.ceil(((parseFloat(y.dosage) * y.rawPrice) / 10000) * 100) /
            100,
          percent_back: parseFloat((y.percentage * 100).toFixed(2)),
          percent_front: y.percentage * 100,
          percent_global_back: parseFloat((y.percentage * 100).toFixed(2)),
          percent_global_front: y.percentage * 100,
          percent_global_granular_back: parseFloat(
            (y.percentage * 100).toFixed(2)
          ),
          percent_global_granular_front: y.percentage * 100,
          percent_granular_back: parseFloat((y.percentage * 100).toFixed(2)),
          percent_granular_front: y.percentage * 100,
        });
      });
      if (error) {
        return true;
      }
    });
    if (error) {
      return;
    }
    singleHerbList.some((y) => {
      if (!isRaw && y.granularPrice == 0 && fromReview) {
        dispatch({
          type: "ERROR",
          payload:
            "Your prescription is invalid, please remove herbs that are unavailable",
        });
        error = true;
        return true;
      }
      if (role.val === 4 && y.isToxic) {
        dispatch({
          type: "ERROR",
          payload:
            "Students are not able to prescribe potentially toxic herbs. Please remove them from the prescription.",
        });
        error = true;
        return true;
      }

      if (!isRaw && y.granularQuantity < y.dosage && fromReview) {
        dispatch({
          type: "ERROR",
          payload:
            "Please remove any herbs from your prescription that are currently out of stock",
        });
        error = true;
        return true;
      }

      if (y.dosage == 0 && fromReview) {
        dispatch({
          type: "ERROR",
          payload: "The minimum dosage can't be zero.",
        });
        error = true;
        return true;
      }

      herbList.push({
        HERB_ID: y.id,
        dosage_front: y.dosage,
        Formula_ID: 0,
        HERB_Display: y.name,
        Is_Custom_Formula: 0,
        MOD_Behavior: y.isModification,
        Is_Form_Additional: 0,
        MOD_ID: 0,
        Price_Granular: y.granularPrice,
        Price_Raw: y.rawPrice,
        dosage_granular_back: y.dosageInFloat,
        dosage_granular_front: y.dosage,
        herb_price_granular:
          Math.ceil(((parseFloat(y.dosage) * y.granularPrice) / 10000) * 100) /
          100,
        herb_price_raw:
          Math.ceil(((parseFloat(y.dosage) * y.rawPrice) / 10000) * 100) / 100,
        percent_back: parseFloat((y.percentage * 100).toFixed(2)),
        percent_front: y.percentage * 100,
        percent_global_back: parseFloat((y.percentage * 100).toFixed(2)),
        percent_global_front: y.percentage * 100,
        percent_global_granular_back: parseFloat(
          (y.percentage * 100).toFixed(2)
        ),
        percent_global_granular_front: y.percentage * 100,
        percent_granular_back: parseFloat((y.percentage * 100).toFixed(2)),
        percent_granular_front: y.percentage * 100,
      });
    });

    if (herbList.length > prescriptionFormFields.maximumHerbsCount) {
      dispatch({
        type: "ERROR",
        payload: `Maximum number of herbs per prescription is ${prescriptionFormFields.maximumHerbsCount}`,
      });
      error = true;
    }
    if (prepMethod.id == 5) {
      if (!isNearMultipleOfValue(parseFloat(overallTotal.totalDosage), 200)) {
        dispatch({
          type: "ERROR",
          payload: `The total dosage should closely
                    approximate a multiple of ${prepMethod.multiple}
                    grams, within -
                    ${prescriptionFormFields.minimumGramForCreation} grams and +
                    ${prescriptionFormFields.maximumGramForCreation} grams.`,
        });
        error = true;
      }
    }

    if (error) {
      return;
    }
    herbList.forEach(
      (x) => (x.dosage_front = x.dosage_front * (isRaw ? totalPacket : 1))
    );
    const data = {
      DC_Custom: disease,
      DC_ID: "",
      DSC_Custom: pattern,
      DSC_ID: "",
      FORM_Custom: formula,
      MOD_Custom: mod,
      PRSC_Dosage_Type: isRaw ? 0 : 1,
      printHerbAmount: printHerbAmount ? 1 : 0,
      PRSC_Markup: commission,
      PRSC_Patient_Instruct: patientInstruction,
      PRSC_Pharmacy_Instruct: pharmacyInstruction,
      PRSC_Practitioner_Note: notesOnPrescription,
      PRSC_Prep_Method: prepMethod?.id,
      PRSC_STATUS_ID: 0,
      PRSC_Serving_Amount: scoops,
      PRSC_Serving_Days: days,
      PRSC_Serving_Per_Day: isRaw ? packetsPerDay : timePerDay,
      PRSC_Serving_Total: isRaw ? totalPacket : 1,
      Serving_Total: isRaw ? totalPacket : 1,
      USER_ID_Patient: patientId,
      PRSC_Created_By_ID: getUserDetail()?.id,
      herbs: herbList,
      action: "savePrescription",
      token: getUserDetail()?.token,
      PRSC_Raw_Daily_Dosage: rawGramPerDayBeforeConversion,
    };
    if (unfinalizedPrescriptionId > 0) {
      data.Prescription_ID = unfinalizedPrescriptionId;
    }

    dispatch(
      practitonerPrescriptionPostAction({ params: data }, (id) => {
        if (!fromSave) {
          dispatch(
            prescriptionPageTabShowItemList([
              ...prescriptionPageTabShowItems,
              4,
            ])
          );
          setActiveSection(3);
        }
        if (id) {
          dispatch(setUnfinalizedPrescriptionId(id));
        }
        dispatch(getCreatePrescriptionPatients());
      })
    );
  };

  const getValueBeforeConversion = () => {
    let dosageBeforeConversion = null;
    formulas.some((x) => {
      x.formulaHerbs.some((y) => {
        debugger;
        dosageBeforeConversion += getFixedDosage(
          (y.dosageInFloat ?? 0 * y.granularUnit ?? 1) / y.rawRatio ?? 1
        );
      });
    });

    singleHerbList.some((y) => {
      dosageBeforeConversion += getFixedDosage(
        (y.dosageInFloat ?? 0 * y.granularUnit ?? 1) / y.rawRatio ?? 1
      );
    });
    return dosageBeforeConversion;
  };

  return (
    <div className="row main-prescription">
      {isLoading && <Loader />}
      {showAddHerb && (
        <AddHerbPopup
          showUnavailableHerbs={prescriptionFormFields.showUnavailableHerbs}
          // showPopup={showAddHerb}
          closePopup={() => setShowAddHerb(false)}
          formulaId={0}
          role={role}
        />
      )}
      {showRawToGranular && (
        <RawToGranularPopup
          setPrepMethod={setPrepMethod}
          isRawType={isRaw}
          closePopup={() => setShowRawToGranular(false)}
          setDays={setDays}
          setRawGram={() =>
            setRawGramPerDayBeforeConversion(getValueBeforeConversion())
          }
          preparationMethods={prescriptionFormFields.preparationMethods}
          setTimePerDay={setTimePerDay}
          setMultiplier={setMultiplier}
          setIsConverted={setIsConverted}
        />
      )}
      {showGranularToRaw && (
        <GranularToRawPopup
          rememberSettings={rememberSettings}
          setPrepMethod={setPrepMethod}
          isRawType={isRaw}
          setDays={setDays}
          setTimePerDay={setTimePerDay}
          closePopup={() => setShowGranularToRaw(false)}
          setRawGram={() =>
            setRawGramPerDayBeforeConversion(getValueBeforeConversion())
          }
          preparationMethods={prescriptionFormFields.preparationMethods}
        />
      )}
      {showFormulaFinderPopup && (
        <FormulaFinderPopup
          closePopup={() => setShowFormulaFinderPopup(false)}
          isRawType={isRaw}
        />
      )}
      {showSuntenRemovePopup && (
        <SuntenRemoveFormulaPopup
          setTimePerDay={setTimePerDay}
          setDays={setDays}
          isRawType={isRaw}
          days={days}
          closePopup={() => setShowSuntenRemovePopup(false)}
          setRawGram={() =>
            setRawGramPerDayBeforeConversion(getValueBeforeConversion())
          }
          formulas={formulas}
        />
      )}
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-5 ">
            <div className="d-flex">
              <p className="page-desc">
                Create your formula using raw dosages, then click convert, and
                we'll handle the calculations.
              </p>
              <div style={{ marginLeft: "5px", cursor: "pointer" }}>
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 200, hide: 100 }}
                  overlay={
                    <Tooltip id="prescription-tooltip">
                      <p style={{ textAlign: "left" }}>
                        In TCM, we are taught to think of herb dosages in grams
                        of RAW herbs per day. For example, the dosage of Chai Hu
                        is 3-12 grams per day in any given formula. When writing
                        a custom granular formula on the other hand, users often
                        get confused because the number of grams indicated on
                        bottles represents the entire prescription, not the
                        daily dosage. Additionally, the dosages in granular
                        formulas vary based on the total grams prescribed and
                        the granular concentrations of each herb. <br />
                        <br />
                        Recent advancements in the herbal extract industry have
                        led companies to extract herbs at different
                        concentrations for optimal effectiveness. While this
                        enhances herb quality, it makes creating custom granular
                        formulas difficult due to the complex math involved in
                        adjusting concentrations and dosages. One herb may have
                        a 5:1 concentration, while another has 16:1, making
                        custom formula writing nearly impossible. Fortunately,
                        our software simplifies this by converting your raw
                        herbal formula into granular form with one click. We
                        also provide the equivalent scoops per day, aligning
                        with the grams-per-day standard used in Chinese
                        medicine. Users simply need to input a RAW formula
                        taking into consideration grams per day of each herb,
                        and our software will handle the rest.
                      </p>
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </OverlayTrigger>
              </div>
            </div>
            <div className="d-flex justify-content-start mt-5 pl-5">
              {" "}
              <ItemSwitch
                itemOneText="Raw"
                itemTwoText="Granular"
                switchText="Convert"
                switchValue={isRaw}
                switchAction={changeFormulaTypeSwitch}
                showSwitchText={
                  singleHerbList?.length > 0 ||
                  formulas.some((x) => x.formulaHerbs.length > 0)
                }
              />
            </div>
          </div>

          <div className="col-md-7">
            <div className="row">
              <div className="col-md-2">
                <div className="icon">
                  <img src={RxIcon} alt="rx-icon" />
                </div>
              </div>
              <div className="col-md-10 border-left">
                <div className="row ">
                  <div className="col-sm-4">PATIENT:</div>
                  <div className="col-sm-6">{patientName}</div>
                </div>
                <div className="row">
                  <div className="col-sm-4">DISEASE:</div>
                  <div className="col-sm-6">
                    <EditableInputWithIcons
                      value={disease}
                      setValue={setDisease}
                    />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-sm-4">PATTERN:</div>
                  <div className="col-sm-6">
                    <EditableInputWithIcons
                      value={pattern}
                      setValue={setPattern}
                    />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-sm-4">
                    <strong>FORMULA(S):</strong>
                    <br />
                    <label className="small">
                      (designated for the purpose of identifying and referencing
                      formula)
                    </label>
                  </div>
                  <div className="col-sm-6">
                    <EditableInputWithIcons
                      value={formula}
                      setValue={setFormula}
                    />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-sm-4">MOD(S):</div>
                  <div className="col-sm-6">
                    <EditableInputWithIcons value={mod} setValue={setMod} />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-sm-4">DOSAGE TYPE:</div>
                  <div className="col-sm-6">{isRaw ? "Raw" : "Granular"}</div>
                </div>
                <div className="row ">
                  <div className="col-sm-4 mt-1">
                    PRINT HERB AMOUNTS ON LABEL:
                  </div>
                  <div className="col-sm-6">
                    <div className="custom-control custom-checkbox custom-popup">
                      <input
                        type="checkbox"
                        className="custom-control-input hidden-checkbox"
                        id="fav"
                        checked={printHerbAmount}
                        onChange={() => setPrintHerbAmount(!printHerbAmount)}
                      />
                      <label
                        className="custom-control-label on-builder"
                        htmlFor="fav"
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6"></div>
          <div className="col-md-6 d-flex align-items-center justify-content-end">
            <div className="col-md-6">
              <button
                className="undo-btn"
                type="button"
                disabled={pastFormulaState.length < 1}
                onClick={() => {
                  dispatch(UndoActionCreators.undo());
                }}
              >
                undo
              </button>
              <img src={UndoIcon} alt="undo-icon" />
              <button
                className="undo-btn"
                disabled={futureFormulaState.length < 1}
                type="button"
                onClick={() => {
                  dispatch(UndoActionCreators.redo());
                }}
              >
                redo
              </button>
            </div>
          </div>
        </div>
        {/* <div className="row mt-3">
          {!isRaw ? (
            <div className="col-md-12 prep-method d-flex  " ref={ref}>
              <b>Preparation Method*</b>
              <div className="prep-method ml-5">
                {prescriptionFormFields.preparationMethods
                  ?.filter((x) => x.isRaw == isRaw && x.status)
                  .map((x) => {
                    return (
                      <div key={x.id}>
                        <label>
                          {x.prepMethod}{" "}
                          {getPreparationValue(x) ? (
                            <>
                              (
                              {getPreparationValue(x)?.toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                                style: "currency",
                                currency: "USD",
                              })}
                              )
                            </>
                          ) : (
                            ""
                          )}
                          <input
                            style={{ marginLeft: "10px" }}
                            type="radio"
                            checked={prepMethod?.id == x.id}
                            onChange={() => {
                              setPrepMethod(x);
                              ref.current.style.border =
                                "1px solid transparent";
                            }}
                            name="prepMethod"
                          />
                        </label>
                        <br />
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : (
            ""
          )}
        </div> */}
        <div className="row mt-2">
          <div className="col-sm-12">
            <p className="page-desc" style={{ margin: "0" }}>
              FORMULA(S)
            </p>
          </div>
          <div className="col-md-12">
            {formulas.map((x) =>
              x.isSuntenFormula ? (
                <SuntenFormula
                  rawGramPerDayBeforeConversion={rawGramPerDayBeforeConversion}
                  isRawType={isRaw}
                  formula={x}
                  key={x.formulaId}
                  isOuterLocked={isLocked}
                />
              ) : (
                <FormulaList
                  showUnavailableHerbs={
                    prescriptionFormFields.showUnavailableHerbs
                  }
                  rawGramPerDayBeforeConversion={rawGramPerDayBeforeConversion}
                  isRawType={isRaw}
                  formula={x}
                  key={x.formulaId}
                  isOuterLocked={isLocked}
                />
              )
            )}
          </div>
          <div className="col-sm-12 mt-2">
            {!(rawGramPerDayBeforeConversion != null && !isRaw) ? (
              <button
                disabled={rawGramPerDayBeforeConversion != null && !isRaw}
                type="button"
                className="btn-orange"
                onClick={() => setShowFormulaFinderPopup(true)}
              >
                Add Formula
              </button>
            ) : null}
          </div>
          <div className="col-md-12">
            <SingleHerbList
              rawGramPerDayBeforeConversion={rawGramPerDayBeforeConversion}
              isRawType={isRaw}
              singleHerbList={singleHerbList}
              isOuterLocked={isLocked}
            />
          </div>
          {!(rawGramPerDayBeforeConversion != null && !isRaw) ? (
            <div className="col-sm-12 mt-2">
              <button
                disabled={rawGramPerDayBeforeConversion != null && !isRaw}
                type="button"
                className="btn-orange"
                onClick={() => setShowAddHerb(true)}
              >
                Add Herb
              </button>
            </div>
          ) : null}
          <div className="col-md-12 mt-4">
            {/* {isRaw && (
              <PacketCounter
                totalPacket={totalPacket}
                setTotalPacket={setTotalPacket}
                setDays={setDays}
              />
            )} */}
            {/* {!isRaw && prescriptionFormFields.showMultiplier && (
              <GranularMultiplier
                multiplier={multiplier}
                setMultiplier={setMultiplier}
              />
            )} */}
            <TotalPrescibed
              rawGramPerDayBeforeConversion={rawGramPerDayBeforeConversion}
              totalDosageRef={totalDosageRef}
              prepMethod={prepMethod}
              isRawType={isRaw}
              overallTotal={overallTotal}
              setIsLocked={setIsLocked}
              isLocked={isLocked}
              totalPacket={isRaw ? totalPacket : 1}
              multiplier={!isRaw ? multiplier : 1}
              isPrescription={true}
              setMultiplier={setMultiplier}
              prescriptionFormFields={prescriptionFormFields}
            />
          </div>
          <div className="col-md-12 mt-1">
            {showCustomPopup && (
              <SaveAsCustomPopup
                closePopup={() => setShowCustomPopup(false)}
                isFavorite={isFavorite}
                formulaName={formulaName}
                formulaNote={formulaNote}
                setFormulaName={setFormulaName}
                setFormulaNote={setFormulaNote}
                setIsFavorite={setIsFavorite}
                saveAsCustomFormula={saveAsCustomFormula}
              />
            )}
            <div className="custom-formula-section">
              <div className="row">
                <div className="col-sm-5">
                  <button
                    className="white-btn"
                    onClick={() => setShowCustomPopup(true)}
                  >
                    Save As Your Custom Formula
                  </button>
                </div>
                <div className="col-sm-5">
                  <label>
                    By clicking this button you will be combining all herbs to
                    create a new Custom Formula.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {!isRaw && (
            <div className="col-md-12">
              <SubtotalSection
                overallTotal={overallTotal}
                isRawType={isRaw}
                totalPacket={isRaw ? totalPacket : 1}
                multiplier={!isRaw ? multiplier : 1}
                commission={commission}
                setCommission={setCommission}
                practitionerCommission={practitionerCommission}
                prepMethod={prepMethod}
                setPrepMethod={setPrepMethod}
                totalValue={totalValue}
                setTotalValue={setTotalValue}
                prepValue={prepValue}
                setPrepValue={setPrepValue}
                preparationMethods={prescriptionFormFields.preparationMethods}
                maximumGramForCreation={
                  prescriptionFormFields.maximumGramForCreation
                }
                minimumTabletQuantity={minimumTabletQuantity}
                minimumGramQuantity={minimumGramQuantity}
                ref={ref}
              />
            </div>
          )}
          {!isRaw ? (
            <div className="col-md-12">
              <ServingsSection
                totalPacket={isRaw ? totalPacket : 1}
                overallTotal={overallTotal}
                isRawType={isRaw}
                packetsPerDay={packetsPerDay}
                setPacketsPerDay={setPacketsPerDay}
                timePerDay={timePerDay}
                setTimePerDay={setTimePerDay}
                scoops={scoops}
                setScoops={setScoops}
                days={days}
                setDays={setDays}
                rawGramPerDayBeforeConversion={rawGramPerDayBeforeConversion}
                prepMethod={prepMethod}
                requireServing={prescriptionFormFields?.requireServing}
                isConverted={isConverted}
              />
            </div>
          ) : (
            ""
          )}

          <div className="col-md-12">
            <PrescriptionNoteSection
              patientInstruction={patientInstruction}
              setPatientInstruction={setPatientInstruction}
              pharmacyInstruction={pharmacyInstruction}
              setPharmacyInsytruction={setPharmacyInsytruction}
              notesOnPrescription={notesOnPrescription}
              setNotesOnPrescription={setNotesOnPrescription}
              ppcId={ppcId}
              fullscriptId={fullscriptId}
              isFullscriptConnected={isFullscriptConnected}
            />
          </div>
          <div className="col-md-12 mt-3">
            <div className="row">
              <div className="col-md-8">
                {prescriptionPageTabShowItems.includes(2) ? (
                  <button
                    className="white-btn"
                    onClick={() => setActiveSection(1)}
                  >
                    <FontAwesomeIcon size="xs" icon={faChevronLeft} /> Back
                  </button>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-4 d-flex justify-content-end">
                <button
                  disabled={appLoading}
                  className="white-btn"
                  onClick={() => {
                    savePrescription(true, true);
                  }}
                >
                  {" "}
                  Save
                </button>
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 200, hide: 100 }}
                  overlay={
                    isRaw ? (
                      <Tooltip>
                        <p style={{ textAlign: "left" }}>
                          Please convert to granular to continue.
                        </p>
                      </Tooltip>
                    ) : (
                      <>
                        <div></div>
                      </>
                    )
                  }
                >
                  <button
                    disabled={appLoading || isRaw}
                    className="white-btn orange"
                    onClick={() => {
                      savePrescription(true, false);
                    }}
                  >
                    {" "}
                    Review <FontAwesomeIcon size="xs" icon={faChevronRight} />
                  </button>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MainPrescriptionPage;
